import { Box, Heading, Text } from '@chakra-ui/react';

interface Props {
  block: {
    type: number;
    label: string;
    options: Map<string, string>;
  };
  content: string[];
}

export default function SelectionBlock({ block, content }: Props) {
  return (
    <Box>
      <Heading as={'h3'} fontSize={'xl'} mb={2}>
        {block.label}
      </Heading>
      {content &&
        content.map((item: string) => (
          <Box key={item} pl={2}>
            <Text fontSize='sm' color='fg.muted'>
              {block.options.has(item) ? block.options.get(item) : item}
            </Text>
          </Box>
        ))}
    </Box>
  );
}
